import { render, staticRenderFns } from "./DiscountAddEditDialog.vue?vue&type=template&id=2678ac9e&scoped=true"
import script from "./DiscountAddEditDialog.vue?vue&type=script&lang=js"
export * from "./DiscountAddEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678ac9e",
  null
  
)

export default component.exports